/**
 * V70-B — 게임대회 게시물 작성자 표시 통일
 *   게임대회 공지·결과 공지·게시판 등 게임대회 게시물의 작성자는 화면에 항상 "관리자"로 표시한다.
 *   - 표시 전용: 저장된 createdBy / createdByName / createdByOrgUnit 등 작성자·감사 정보는 그대로 둔다.
 *   - 일반 ERP 공지사항에는 적용하지 않는다 (게임대회 화면에서만 사용).
 *   - 관리자 화면의 변경 이력·승인자 등 감사 기록 표시는 대상이 아니다.
 */
export const TOURNAMENT_AUTHOR_LABEL = '관리자';

/** 저장된 작성자명과 무관하게 게임대회 게시물 작성자 표시값을 돌려준다. */
export function tournamentAuthorLabel(_storedName?: string | null): string {
  return TOURNAMENT_AUTHOR_LABEL;
}
